import { render, staticRenderFns } from "./sidebarless.vue?vue&type=template&id=753c9aa8&"
import script from "./sidebarless.vue?vue&type=script&lang=js&"
export * from "./sidebarless.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loading: require('/Users/yasumura65/Dev/pico/knowledgeloop-trial/components/layouts/Loading.vue').default})
